import React, { Component } from 'react';
import {
  inject,
  observer,
} from 'mobx-react';
import Tabs from 'react-bootstrap/lib/Tabs';
import Tab from 'react-bootstrap/lib/Tab';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import MaterialTable from './MaterialTable';
import CutoffTable from './CutoffTable';
import MaterialSettings from './MaterialSettings';
import InventoryAdjust from './InventoryAdjust';
import ShipInMaterial from './ShipInMaterial/ShipInMaterial';
import PageWrap from '../../components/PageWrap/PageWrap';
import DeliveryHistory from './DeliveryHistory';
import {
  Portlet,
  PortletActions,
  PortletBody,
  PortletCaption,
  PortletTitle,
} from '../../components/Bootstrap/Portlet';
import { withTranslation } from 'react-i18next';
import moment from 'moment-timezone';
import PageLoading from '../../components/PageLoading/PageLoading';
import Reports from './Reports/Reports';
import EditDevice from '../Devices/EditDevice';

class Materials extends Component {
  constructor(props) {
    super(props);
    this.mounted = false;
    this.state = {
      editingMaterial: null,
      adjustingMaterialId: null,
      shipInMaterialId: null,
      historyMaterialId: null,
      showReport: false,
      loading: false,
    };
  }

  componentWillMount() {
    const { materialStore, devicesStore } = this.props;

    if (!materialStore.unit.length) {
      materialStore.loadTypes();
    }

    if (!materialStore.materialDetailsLoaded) {
      materialStore.loadMaterials();
    }

    if (!devicesStore.devices.length) {
      devicesStore.loadDevices();
    }
  }

  componentDidMount () {
    this.mounted = true;
  }

  componentWillUnmount () {
    this.mounted = false;
  }

  resetState = () => {
    this.setState({
      editingMaterial: null,
      adjustingMaterialId: null,
      shipInMaterialId: null,
      historyMaterialId: null,
      showReport: false,
      loading: false,
    });

    const { devicesStore } = this.props;
    devicesStore.cancelEdit();
  };

  onEditMaterial = editingMaterial => {
    this.resetState();
    setTimeout(() => {
      this.setState({ editingMaterial });
    }, 0);
  };

  onAdjustMaterial = adjustingMaterialId => {
    this.resetState();
    setTimeout(() => {
      this.setState({ adjustingMaterialId });
    }, 0);
  };

  onShipInMaterial = shipInMaterialId => {
    this.resetState();
    setTimeout(() => {
      this.setState({ shipInMaterialId });
    }, 0);
  };

  onHistoryMaterial = historyMaterialId => {
    const { shipHistoryStore, notifierStore } = this.props;

    if (!historyMaterialId) {
      notifierStore.showWarning('No inventory ID');
      return;
    }

    shipHistoryStore.showHistory(historyMaterialId);
    this.resetState();
    setTimeout(() => {
      this.setState({ historyMaterialId });
    }, 0);
  };

  toggleReport = () => {
    this.resetState();
    setTimeout(() => {
      this.setState({ showReport: !this.state.showReport });
    }, 0);
  };

  printMaterials() {
    const { materialStore, printStore, settingsStore, locationsStore } = this.props;
    const { loading } = this.state;
    if (loading) {
      return;
    }

    const timezone = settingsStore.configuration.ianaTimeZone;
    const data = {
      materials: materialStore.assignedMaterials,
      printDate: moment().tz(timezone).format('LLL'),
      plant: locationsStore.currentPlant.description,
      location: locationsStore.currentLocation.name,
    };

    const t = document.querySelectorAll('.material-table .rt-table');
    let html = '';
    t.forEach((v, i) => {
      if (i < 3) {
        html += v.innerHTML;
      }
    });
    printStore.printHtml(`
      <h2>${data.plant}, ${data.location}</h2>
      ${html}
      <h5>${data.printDate}</h5>
      `);
  }

  render() {
    const { materialStore, devicesStore, t } = this.props;
    const { isEditing: isEditingDevice } = devicesStore;
    const {
      unassignedMaterials,
      weighedMaterials,
      meteredMaterials,
      otherMaterials,
    } = materialStore;
    const { editingMaterial, adjustingMaterialId, shipInMaterialId, showReport, historyMaterialId,  loading } = this.state;

    return (
      <PageWrap page={t('nav.Materials')}>
        {loading && <PageLoading />}
        <Row>
          <Col sm={12} lg={6}>
            <Portlet>
              <PortletTitle>
                <PortletCaption subject={t('nav.Materials')}/>
                <PortletActions>
                  <a className="btn btn-sm btn-simple hidden-xs" onClick={() => this.printMaterials()}>
                    <i className="fa fa-print"/> {t('Print')}
                  </a>
                  <a className="btn btn-sm btn-simple hidden-xs" onClick={this.toggleReport}>
                    <i className="fa fa-calculator"/> {t('Reports')}
                  </a>
                </PortletActions>
              </PortletTitle>
              <PortletBody>
                <Tabs defaultActiveKey={1} id="materials">
                  <Tab eventKey={1} title={t('Weighed')}>
                    <MaterialTable
                      items={weighedMaterials}
                      type="weighed"
                      onEditMaterial={this.onEditMaterial}
                      onAdjustMaterial={this.onAdjustMaterial}
                      onShipInMaterial={this.onShipInMaterial}
                      onHistoryMaterial={this.onHistoryMaterial}
                    />
                  </Tab>
                  <Tab eventKey={2} title={t('Metered')}>
                    <MaterialTable
                      items={meteredMaterials}
                      type="metered"
                      onEditMaterial={this.onEditMaterial}
                      onAdjustMaterial={this.onAdjustMaterial}
                      onShipInMaterial={this.onShipInMaterial}
                      onHistoryMaterial={this.onHistoryMaterial}
                    />
                  </Tab>
                  <Tab eventKey={3} title={t('Other')}>
                    <MaterialTable
                      items={otherMaterials}
                      type="other"
                      onEditMaterial={this.onEditMaterial}
                      onAdjustMaterial={this.onAdjustMaterial}
                      onShipInMaterial={this.onShipInMaterial}
                      onHistoryMaterial={this.onHistoryMaterial}
                    />
                  </Tab>
                  <Tab eventKey={4} title={t('Unassigned')}>
                    <MaterialTable
                      items={unassignedMaterials}
                      type="unassigned"
                      onEditMaterial={this.onEditMaterial}
                    />
                  </Tab>
                </Tabs>
              </PortletBody>
            </Portlet>
          </Col>
          <Col sm={12} lg={6}>
            {isEditingDevice && (
              <Portlet>
                <PortletBody>
                  <EditDevice />
                </PortletBody>
              </Portlet>
            )}
            {editingMaterial && (
              <Portlet>
                <PortletBody>
                  <MaterialSettings
                    editingMaterial={editingMaterial}
                    cancelEdit={this.resetState}
                  />
                </PortletBody>
              </Portlet>
            )}

            {shipInMaterialId && (
              <Portlet>
                <PortletBody>
                  <ShipInMaterial
                    inventoryId={shipInMaterialId}
                    onClose={this.resetState}
                  />
                </PortletBody>
              </Portlet>
            )}

            {adjustingMaterialId && (
              <Portlet>
                <PortletBody>
                  < InventoryAdjust
                    materialId={adjustingMaterialId}
                    onClose={this.resetState}
                  />
                </PortletBody>
              </Portlet>
            )}

            {showReport &&
                <Reports/>
            }

            {historyMaterialId && (
              <DeliveryHistory
                onClose={this.resetState}
              />
            )}

            <CutoffTable />
          </Col>
        </Row>
      </PageWrap>
    );
  }
}

export default withTranslation()(inject('materialStore', 'notifierStore', 'printStore', 'shipHistoryStore', 'devicesStore', 'settingsStore', 'locationsStore')(observer(Materials)));
